var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 15",
    style: {
      enableBackground: "new 0 0 16 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CB8B65;stroke:#CB8B65;stroke-width:0.2607;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,13.6c-1-1.7-2.5-3-4.3-3.6c0.8-0.6,1.5-1.4,1.9-2.3c0.4-1,0.5-2.1,0.2-3.2c-0.3-1.1-0.9-2-1.8-2.7 c-0.9-0.7-1.9-1-3-1c-1.1,0-2.2,0.4-3,1S3.1,3.4,2.9,4.4C2.6,5.5,2.6,6.6,3,7.6c0.4,0.9,1,1.7,1.9,2.3c-1.8,0.6-3.3,1.9-4.3,3.6 c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3,0 c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2c1.3-2.2,3.5-3.5,5.9-3.5c2.5,0,4.7,1.3,5.9,3.5c0,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.2,0-0.3 C14.9,13.7,14.8,13.6,14.8,13.6z M4,5.8c0-0.7,0.2-1.4,0.6-2c0.4-0.6,1-1.1,1.6-1.4C7,2.1,7.7,2,8.4,2.2c0.7,0.1,1.4,0.5,1.9,1 c0.5,0.5,0.9,1.2,1,1.9c0.1,0.7,0.1,1.5-0.2,2.1c-0.3,0.7-0.7,1.2-1.4,1.6c-0.6,0.4-1.3,0.6-2,0.6c-1,0-1.9-0.4-2.6-1.1 C4.4,7.7,4,6.7,4,5.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.72639261da28165e3152a032e975b050.svg";
export { ForwardRef as ReactComponent };